import { ComponentStatus } from '@christies/react/typings'
import useSWR from 'swr'
import { dataFetcher, Endpoint } from './dataFetcher'

interface Media {
  type: string
  alt: string
  description: string
  primary: {
    href: string
  }
}

interface Flags {
  hideInArchive: boolean
  showVideoArrow: boolean
}

export interface RelatedContent {
  type: string
  values: {
    type: string
    id: string
  }[]
}

interface Tag {
  type: string
  values: {
    id: string
    value: string
  }[]
}

export interface Relations {
  type: string
  values: string[]
}

export interface RelatedContentResponse {
  id: string
  storyId: number
  title: string
  subTitle: string
  storySlug: string
  storyTheme: string
  flags: Flags
  media: Media[]
  relatedContent: RelatedContent[]
  tags: Tag[]
  relations: Relations[]
}

export interface GroupedContent {
  relatedContent: RelatedContent[]
  relations: Relations[]
}

export interface RelatedContentKey {
  storyAPIEndpoint: Endpoint
}

export const useRelatedContentData = (
  storyAPIEndpoint: Endpoint | null
): { data: GroupedContent; status: ComponentStatus } => {
  const { data, isLoading, error } = useSWR(storyAPIEndpoint ?? null, dataFetcher<RelatedContentResponse>)
  const groupedContent: GroupedContent = {
    relations: data?.relations || [],
    relatedContent: data?.relatedContent || [],
  }

  const getStatus = (): ComponentStatus => {
    if (!storyAPIEndpoint || isLoading) {
      return 'initial'
    }
    if (error || Object.values(groupedContent).every((relation) => !relation.length)) {
      return 'error'
    }
    return 'ready'
  }

  return { data: groupedContent, status: getStatus() }
}
